(() => {
    const cards = document.querySelectorAll("[data-video-card]");
    if (cards.length === 0) return;

    cards.forEach((card) => {
        const video = card.querySelector(".video-el");
        const thumb = card.querySelector(".video-thumb");
        const playBtn = card.querySelector(".video-play");
        if (!video || !thumb || !playBtn) return;

        const showPlay = () => playBtn.classList.add("is-visible");
        const hidePlay = () => playBtn.classList.remove("is-visible");
        const showThumb = () => thumb.classList.add("is-visible");
        const hideThumb = () => thumb.classList.remove("is-visible");
        const showVideo = () => video.classList.add("is-visible");
        const hideVideo = () => video.classList.remove("is-visible");

        video.controls = false;
        video.removeAttribute("controls");

        showThumb();
        showPlay();
        hideVideo();

        playBtn.addEventListener("click", async (e) => {
            e.preventDefault();
            try {
                await video.play();
            } catch (_) {}
        });

        video.addEventListener("click", async () => {
            if (video.paused || video.ended) {
                try {
                    await video.play();
                } catch (_) {}
            } else {
                video.pause();
            }
        });

        video.addEventListener("play", () => {
            showVideo();
            hideThumb();
            hidePlay();
        });

        video.addEventListener("pause", () => {
            showPlay();
            hideThumb();
            showVideo();
        });

        video.addEventListener("ended", () => {
            showPlay();
            showThumb();
            hideVideo();
            try {
                video.currentTime = 0;
            } catch (_) {}
        });
    });
})();
